<template>
  <div>
      <b-tabs v-model="tabIndex">
          <b-tab :title="'Técnico'">
            <template slot="title" >
            <span class="d-md-down-none pl-1 text-third">Engenheiro</span>
            </template>
              <tableOcorrencia ref="tableEngenheiro" :tipo="engenheiro"></tableOcorrencia>
           </b-tab>

           <b-tab :title="'Engenheiro'">
            <template slot="title" >
            <span class="d-md-down-none pl-1 text-third">Técnicos</span>
            </template>
              <tableOcorrencia ref="tableTecnico" :tipo="tecnico"></tableOcorrencia>
           </b-tab>
      </b-tabs>
  </div>
</template>

<script>
import colapse from './colapse'
export default colapse
</script>
<style scoped>
.custom-control-input:checked~.custom-control-label::before {
  border-color: #9cd9a3;
  background-color: #9cd9a3
}
.icone-alerta {
  display: flex;
  margin: 1rem 0 1rem 0;
  justify-content: center;
  font-size: 55px;
  color: darkgreen;
}
.font-clone{
  display: flex;
  justify-content: center;
  color: rgb(128, 128, 128);
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 10px;
 }

  .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .add{
    margin-right: 0.6rem;
    cursor: pointer;
    padding: 5px;
  }
  .excDisable{
    margin-right: 1rem;
    cursor: pointer;
    border: transparent;
    border-radius: 6px;
    background-color: rgb(191, 191, 191);
    color: rgb(64, 64, 64);
    padding: 5px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .exc{
    margin-right: 1rem;
    border: transparent;
    cursor: pointer;
    border-radius: 6px;
    background-color: rgb(255, 205, 205);
    color: rgb(136, 22, 22);
    padding: 5px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .excPreRequisito{
    margin-right: 0rem;
    cursor: pointer;
    border-radius: 3px;
    width: 2rem;
    border: 1px solid rgb(136, 22, 22);
    color: rgb(136, 22, 22);
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .font-bold {
    font-weight: bold;
  }
  .font {
    font-family: 'Segoe UI';
    font-size: 12px;
  }

.margim{
  margin-top: 1rem;
}
.col-md-3{
  padding-right: 0;
  padding-left: 0;
 }
.title-card-sales {
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.buton_salvar{
  display: flex;
  float: right;
  justify-content: end;
}
.buttonsave{
  margin-top: 10;
  font-size: 12px;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 170px;
  height: 30px;
  background-color: #008144;
  color: white;
}
.buttonsavedisable{
  margin-top: 10;
  font-size: 12px;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 170px;
  height: 30px;
  background-color: rgb(191, 191, 191);
  color: rgb(64, 64, 64);
}
.button-cancel{
  background-color: #b60000;
  margin-top: 10;
  font-size: 12px;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 100px;
  height: 30px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/occurrenceMaintenance/components/colapse/colapse.vue